// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"268":"events","353":"contact","594":"about"}[chunkId] + "." + {"268":"d85ec114","353":"03a710c2","594":"d9d8e1a6"}[chunkId] + ".js";
};